import { render, staticRenderFns } from "./selectStudy.vue?vue&type=template&id=57b98ba0&scoped=true"
import script from "./selectStudy.vue?vue&type=script&lang=js"
export * from "./selectStudy.vue?vue&type=script&lang=js"
import style0 from "./selectStudy.vue?vue&type=style&index=0&id=57b98ba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b98ba0",
  null
  
)

export default component.exports